import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import joinPlatformImg from './images/join-platform.png';

const useStyles = makeStyles((theme) => ({
  sectionWrapper: {
    width: '100%',
    backgroundColor: '#0f0f0f',
    paddingBottom: '30px',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '10px',
      backgroundColor: '#141414',
    }
  },
  section: {
    maxWidth: '1314px',
    width: '100%',
    margin: '0 auto',
    padding: '90px 24px 40px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      margin: '0 auto',
      padding: '10px 20px 20px',
    }
  },
  ctaContainer: {
    background: 'linear-gradient(90deg, #CE949C 0%, #E6B1BD 25%, #FFD0E1 55%, #CE949C 100%)',
    borderRadius: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 60px',
    position: 'relative',
    height: 326,
    maxHeight: 326,
    overflow: 'visible',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      padding: '0 40px',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: '30px 20px 0',
      textAlign: 'center',
      height: 'auto',
      maxHeight: 'none',
      overflow: 'hidden',
    }
  },
  ctaContent: {
    maxWidth: '520px',
    zIndex: 2,
    padding: '0',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      padding: '0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }
  },
  ctaTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: '52px',
    fontWeight: 400,
    lineHeight: '100%',
    color: '#111111',
    marginBottom: '12px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '36px',
      lineHeight: '100%',
      width: '290px',
      color: "#0C0A09"
    }
  },
  ctaSubtitle: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    color: '#111111',
    marginBottom: '24px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      lineHeight: '21px',
      width: '90%',
    }
  },
  buttonRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
      gap: '12px',
    }
  },
  btnMember: {
    backgroundColor: '#FD3C84',
    color: '#ffffff',
    padding: '12px 28px',
    borderRadius: '6px',
    fontSize: '16px',
    height: '48px',
    fontWeight: 600,
    border: 'none',
    fontFamily: "'Roboto', sans-serif",
    cursor: 'pointer',
    // boxShadow: '0 4px 14px rgba(253, 60, 132, 0.3)',
    transition: 'transform 0.2s, background-color 0.2s',
    [theme.breakpoints.down('sm')]: {
      width: '80%',
      maxWidth: '280px',
      height: '38px',
      padding: '6px 24px',
    },
    '&:hover': {
      transform: 'translateY(-1px)',
      backgroundColor: '#ff4081',
    }
  },
  btnCreator: {
    backgroundColor: 'transparent',
    color: '#FD3C84',
    padding: '12px 28px',
    borderRadius: '6px',
    fontSize: '16px',
    height: '48px',
    fontWeight: 600,
    border: '1px solid #FD3C84',
    fontFamily: "'Roboto', sans-serif",
    cursor: 'pointer',
    transition: 'transform 0.2s, background-color 0.2s',
    [theme.breakpoints.down('sm')]: {
      width: '80%',
      maxWidth: '280px',
      height: '38px',
      padding: '6px 24px',
    },
    '&:hover': {
      transform: 'translateY(-1px)',
      backgroundColor: 'rgba(253, 60, 132, 0.16)',
    }
  },
  ctaImageContainer: {
    position: 'absolute',
    right: '40px',
    bottom: 0,
    height: '420px',
    zIndex: 3,
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'flex-end',
    [theme.breakpoints.down('md')]: {
      right: '20px',
      height: '370px',
    },
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      right: 0,
      bottom: 0,
      width: '100%',
      height: 'auto',
      justifyContent: 'center',
      marginTop: '8px',
      lineHeight: 0,
    }
  },
  ctaImage: {
    height: '420px',
    width: 'auto',
    objectFit: 'contain',
    objectPosition: 'bottom right',
    display: 'block',
    verticalAlign: 'bottom',
    [theme.breakpoints.down('md')]: {
      height: '370px',
    },
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      width: '100%',
      maxWidth: '380px',
      maxHeight: '340px',
      objectFit: 'contain',
      objectPosition: 'bottom center',
      display: 'block',
    }
  }
}));

export const AboutUsJourneyCTASection = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Box className={classes.sectionWrapper}>
      <Box className={classes.section}>
        <Box className={classes.ctaContainer}>
          <Box className={classes.ctaContent}>
            <Typography className={classes.ctaTitle}>
              Join a Platform Built for Premium Experiences
            </Typography>
            <Typography className={classes.ctaSubtitle}>
              Whether you're a premium creator looking to grow your business or a member seeking exclusive access, SugarCribs is designed to deliver a more curated, trusted, and rewarding experience.
            </Typography>

            <Box className={classes.buttonRow}>
              <button
                className={classes.btnMember}
                onClick={() => history.push('/member-onboarding-step')}
              >
                Request Member Access
              </button>
              <button
                className={classes.btnCreator}
                onClick={() => history.push('/apply-as-creator')}
              >
                Apply As Creator
              </button>
            </Box>
          </Box>

          <Box className={classes.ctaImageContainer}>
            <img
              src={joinPlatformImg}
              alt="Join a Platform Built for Premium Experiences"
              className={classes.ctaImage}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AboutUsJourneyCTASection;
